import React, { useState } from "react";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { ChargeFields } from "../Fields";
import {
  Alert,
  Box,
  Button,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import ErrorsList from "../../../ui/ErrorsList";
import { createYupSchema } from "../../../utilities/yupSchemaCreator";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import "dayjs/locale/de";
import "dayjs/locale/en-gb";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { CalDate } from "../../../utilities/functions";
import { PaymentTypeForm } from "../../../utilities/Enum";
import { useMember } from "../provider";
const yupSchema = ChargeFields.reduce(createYupSchema, {
  amount: Yup.number().required("required"),
  paymentTypeId: Yup.number().required("required"),
  expireDate: Yup.string().required("required"),
});
const schema = Yup.object().shape(yupSchema);
const FormCharge = ({ row, handleClose }) => {
  const [locale] = useState("en-gb");

  const [error, setError] = useState();
  const theme = useTheme();
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const { ChargeAPI } = useMember();
  const onSubmit = async (values) => {
    try {
      await ChargeAPI(values, row?.id);
      handleClose();
    } catch (error) {
      window.scroll(0, 0);
      setError({
        title: error.errors.message ? error.errors.message : "some thing wrong",
      });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <Typography
        sx={{ textAlign: "center", marginRight: "10px" }}
        variant="Poster"
        component="h4"
        gutterBottom
      >
        Charge Now
      </Typography>
      {error ? (
        <Alert severity="error" sx={{ my: 3 }}>
          <ErrorsList error={error} />
        </Alert>
      ) : (
        ""
      )}
      <Box>
        {ChargeFields.map((f, index) => (
          <Box key={index}>
            {f.select ? (
              <FormControl
                sx={{
                  mt: theme.dimensions.mt,
                  mb: theme.dimensions.mb,
                  width: theme.dimensions.width,
                }}
                error={!!errors["paymentTypeId"]}
              >
                <span style={{ fontSize: "12px" }}>{f.label}</span>
                <Select
                  sx={{
                    mt: theme.dimensions.mt,
                  }}
                  inputProps={{
                    ...register("paymentTypeId"),
                  }}
                  size="small"
                >
                  {PaymentTypeForm?.map((type, index) => (
                    <MenuItem key={index} value={type.id}>
                      {type.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : (
              <Box>
                {f.date ? (
                  <Box>
                    <LocalizationProvider
                      key={f.name}
                      dateAdapter={AdapterDayjs}
                      adapterLocale={locale}
                    >
                      <div components={["DateRangePicker"]}>
                        <DatePicker
                          label={f.label}
                          onChange={(date) => setValue(f.name, CalDate(date))}
                          error={!!errors[f.name]}
                          slotProps={{
                            textField: {
                              required: f.required,
                              error: errors[f.name]?.message,
                              helperText: (
                                <p style={{ color: "#d32f2f" }}>
                                  {errors[f.name]?.message}
                                </p>
                              ),
                              size: "small",
                            },
                          }}
                          sx={{ mt: 2, width: "300px" }}
                        />
                      </div>
                    </LocalizationProvider>
                  </Box>
                ) : (
                  <Box>
                    <FormControl
                      sx={{
                        width: theme.dimensions.width,
                        mt: theme.dimensions.mt,
                        mb: theme.dimensions.mb,
                      }}
                    >
                      <span style={{ fontSize: "12px" }}>{f.label}</span>
                      <TextField
                        name={f.name}
                        error={!!errors[f.name]}
                        helperText={errors[f.name]?.message}
                        type={f.type}
                        fullWidth
                        disabled={f.disabled}
                        required={f.required}
                        sx={{
                          width: theme.dimensions.width,
                        }}
                        inputProps={{
                          ...register(f?.name),
                          required: f.required,
                        }}
                        size="small"
                      />
                    </FormControl>
                  </Box>
                )}
              </Box>
            )}
          </Box>
        ))}
      </Box>

      <Box sx={{ width: theme.dimensions.width }}>
        <Button
          type="submit"
          sx={{
            background: theme.color.blackBackground,
            color: "white",
            width: "100%",
            mb: 1.3,
            "&:hover": {
              background: `${theme.color.black}`,
            },
          }}
        >
          Save
        </Button>
        <Button
          onClick={handleClose}
          sx={{
            background: theme.color.gray200,
            color: "black",
            width: "100%",
            "&:hover": {
              background: `${theme.color.gray300}`,
            },
          }}
        >
          Cancel
        </Button>
      </Box>
    </form>
  );
};

export default FormCharge;
